import React, { Component } from 'react';
import AboutCard from './aboutCard';
import BoardCard from './boardCard';
import BoardCardTwo from './boardCtwo';
import { Button } from '@material-ui/core';
import SponsorPage from './SponsorsPage';
import SponsorPageTwo from './SponsorsPageTwo';

export default class About extends Component {
    render() {
        return (

            <React.Fragment>
                <AboutCard/>

                <div className='board-container'>

                <div className="board-container">
                    <div>
                        <h3>Mission Statement</h3>
                        <div className="mission-statement">
                            <p>
                                The Alan J Anderson Foundation is a registered 501(c)(3) charitable nonprofit organization dedicated to honoring Alan’s legacy and carrying forward the values he lived by. 
                                The Foundation supports its mission by funding organizations devoted to eliminating cancer and supporting those affected by the disease. 
                                It also invests in the future by awarding academic and athletic scholarships to exceptional students and student-athletes at William Paterson University and New Milford High School in New Jersey.
                            </p>
                        </div>
                    </div>
                </div>

                    <div>
                        <h1> Meet The Board </h1>
                    </div>
                    <BoardCardTwo/>
                </div>

                <SponsorPageTwo/>

            </React.Fragment>
        )
    }
}
